var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaughtup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C31.0383 0 40 8.96167 40 20C40 31.0383 31.0383 40 20 40C8.96167 40 0 31.0383 0 20C0 8.96167 8.96167 0 20 0ZM20 1.66667C30.1183 1.66667 38.3333 9.88167 38.3333 20C38.3333 30.1183 30.1183 38.3333 20 38.3333C9.88167 38.3333 1.66667 30.1183 1.66667 20C1.66667 9.88167 9.88167 1.66667 20 1.66667ZM31.6667 14.095L16.6583 30.0367L8.33333 20.2617L9.60167 19.18L16.72 27.54L30.4533 12.9533L31.6667 14.095Z",
    fill: "#6418C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaughtup);
export default __webpack_public_path__ + "static/media/caughtup.586a20c54da6530bae144dd3151d66d6.svg";
export { ForwardRef as ReactComponent };